import RedirectToHome from "./RedirectToHome";

export default RedirectToHome;